<template>
<gap block="true"
     top="double"
     left="negative-single"
     right="negative-single">
    <wrap :color="color === 'default' ? 'info' : color" margins="false">
        <gap right="single"
             left="single"
             top="single"
             bottom="single">
            <row>
                <column fixed="true" noMargin="true">
                    <gap right="single">
                        <icon color="gray">info_outline</icon>
                    </gap>
                </column>
                <column>
                    <gap style="margin-top: 2px !important;">
                        <slot></slot>
                    </gap>
                </column>
            </row>
        </gap>
    </wrap>
</gap>
</template>
<script>
import { coloringMixin } from '../mixins/coloring'

export default {
    mixins: [coloringMixin],
    components: {
        row: require('./row.vue').default,
        wrap: require('./wrap.vue').default,
        column: require('./column.vue').default,
        gap: require('./gap.vue').default,
        icon: require('./icon.vue').default,
    },
}
</script>
